import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { ContributionClassRolesDDL } from 'types/contribution';
import { ContributionFormData } from '../types';
import { RoleRadioField } from '../ContributionClassNameRadioField';

interface RoleSelectionFieldProps {
  contributorClassNameDisabled?: boolean;
  classes: ContributionClassRolesDDL;
}

export const RoleSelectionField: React.FC<RoleSelectionFieldProps> = ({
  contributorClassNameDisabled,
  classes,
}) => {
  const { control } = useFormContext<ContributionFormData>();

  return (
    <Controller
      name="className"
      control={control}
      render={({ field: { onChange, value } }) => (
        <RoleRadioField
          classes={classes}
          onChange={onChange}
          value={value}
          disabled={contributorClassNameDisabled}
        />
      )}
    />
  );
};
